module.exports = __webpack_public_path__ + "static/media/vaseWrong.b8088680.png";